import { render, staticRenderFns } from "./TeamBreakRowComponent.vue?vue&type=template&id=38599a34&scoped=true&"
import script from "./TeamBreakRowComponent.vue?vue&type=script&lang=js&"
export * from "./TeamBreakRowComponent.vue?vue&type=script&lang=js&"
import style0 from "./TeamBreakRowComponent.vue?vue&type=style&index=0&id=38599a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38599a34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38599a34')) {
      api.createRecord('38599a34', component.options)
    } else {
      api.reload('38599a34', component.options)
    }
    module.hot.accept("./TeamBreakRowComponent.vue?vue&type=template&id=38599a34&scoped=true&", function () {
      api.rerender('38599a34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/BreakManagement/components/TeamBreakRowComponent.vue"
export default component.exports